module.exports = __webpack_public_path__ + "comp-4.png?47db2c342b1005d57bfc0a37f04696e5";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/integrations/comp-4.png
// module id = itFZ
// module chunks = 46